<template lang="pug">
div
	v-jnx-person-name(section-title='', :data='contact', :is-valid="isValid")
	v-jnx-email(section-title='party.emailsTitle', :data='contact', :is-valid="isValid")
	.field-title Company
	// .error-val.error-contact(v-if="contact.company === ''") Enter Company value
	.each-field-contact: b-form-input.all-fields(v-model='contact.company')
	v-jnx-address(section-title='party.addressesTitle', :data='contact', :is-valid="isValid", :isCheckout="isCheckout", :isRequired="isRequired")
	v-jnx-phone(section-title='party.phonesTitle', :data='contact', :is-valid="isValid", :isCheckout="isCheckout", :isRequired="isRequired")
</template>

<script>
import {Person, PhoneNumber, EmailAddress, PostalAddress} from 'janux-people'
import _ from 'lodash'

export default {
	name: 'person',
	props: ['data', 'isValid', 'isCheckout', 'isRequired'],
	data () {
		return {
			contact: {}
		}
	},
	beforeMount () {
		this.isValid.name = false
		this.isValid.address = false
		this.isValid.email = false
		this.isValid.phone = false
	},
	created () {
		if (_.isNil(this.data)) {
			let contactObj = new Person()
			contactObj.setContactMethod('WORK', new PhoneNumber())
			contactObj.setContactMethod('WORK', new EmailAddress())
			contactObj.setContactMethod('WORK', new PostalAddress())
			this.contact = contactObj
		} else if (typeof this.data === 'object') {
			this.contact = this.data
		} else {
			console.error('trying to create a person component without a valid Janux Person instance', typeof this.data)
		}
	}
}
</script>



// WEBPACK FOOTER //
// ../../easytitle24-2.x-common/components/party/person.vue